import * as jsCookie from "js-cookie";
import { COOKIE_CHANGE_EVENT } from "Constants/eventTypes";

type CookieName = "wec_cookies";

export class CookieService {
  cookiesAccepted: boolean;

  constructor() {
    this.cookiesAccepted = this.getCookie("wec_cookies") === "1";
  }

  /* ====================================================
                  Basic Funtionality
    ==================================================*/

  /**
   * Returns string[] of allowed CookieName
   * @returns {string[]}
   */
  get cookieList(): string[] {
    return ["ode_cookies"];
  }

  /**
   * returns true, if cookies were accepted by the user
   * @returns {boolean}
   */
  get cookiesAllowed(): boolean {
    if (!this.cookiesAccepted) console.warn("Cookies not allowed yet");

    return this.cookiesAccepted;
  }

  /**
   * sets Cookie, if User alloed Cookies
   * @param {CookieName} cookieName
   * @param {string} cookieValue
   * @param {number} expiresIn days until the cookie expires...defaults to 365
   */
  setCookie(cookieName: CookieName, cookieValue: string, expiresIn = 365): void {
    if (!this.cookiesAllowed) return;

    jsCookie.set(cookieName, cookieValue, { expires: expiresIn });
    window.dispatchEvent(
      new CustomEvent(COOKIE_CHANGE_EVENT, {
        detail: {
          cookieName,
          cookieValue,
        },
      }),
    );
  }

  /**
   * returns value of specific Cookie
   * @param {CookieName} cookieName
   * @returns {string | undefined}
   */
  getCookie(cookieName: CookieName): string | undefined {
    return jsCookie.get(cookieName);
  }

  /**
   * returns, whether as specific cookie is set
   * @param {CookieName} cookieName
   * @returns {boolean}
   */
  isCookieSet(cookieName: CookieName): boolean {
    return this.getCookie(cookieName) !== undefined;
  }

  /**
   * allows Service to set Cookies
   */
  allowCookies(): void {
    if (this.cookiesAccepted) return;

    this.cookiesAccepted = true;
    this.setCookie("wec_cookies", "1");
  }
}

export default new CookieService();
